import { mapActions, mapGetters } from 'vuex';

/**
 *
 * @param storeModule
 */
export function DocumentState(storeModule) {
  return {
    data() {
      return {
        document: {
          id: null,
          documentType: null,
          serialNumber: null,
          documentNumber: null,
          issuingAuthority: null,
          issueDate: null,
          expirationDate: null,
        },
      };
    },
    mounted() {
      this.document = {
        ...this.document,
        id: this.getDocumentId,
        documentType: this.getDocumentType,
        serialNumber: this.getDocumentSerialNumber,
        documentNumber: this.getDocumentNumber,
        issuingAuthority: this.getDocumentIssuingAuthority,
        issueDate: this.getDocumentIssueDate,
        expirationDate: this.getDocumentExpirationDate,
      };
    },
    computed: {
      ...mapGetters(storeModule, [
        'getDocumentId', 'getDocumentType', 'getDocumentSerialNumber', 'getDocumentNumber',
        'getDocumentIssuingAuthority', 'getDocumentIssueDate', 'getDocumentExpirationDate',
      ]),
      isValid() {
        return this.document.id && this.document.documentNumber;
      },
      isExpired() {
        if (!this.document.expirationDate) return false;
        return new Date(this.document.expirationDate) < new Date();
      },
    },
    methods: {
      ...mapActions(storeModule, [
        'setDocumentId', 'setDocumentType', 'setDocumentSerialNumber', 'setDocumentNumber',
        'setDocumentIssuingAuthority', 'setDocumentIssueDate', 'setDocumentExpirationDate',
      ]),
      documentClear() {
        this.document = {
          ...this.document,
          id: null,
          documentType: null,
          serialNumber: null,
          documentNumber: null,
          issuingAuthority: null,
          issueDate: null,
          expirationDate: null,
        };
      }
    },
    watch: {
      'document.id'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentId(newValue);
        }
      },
      'document.documentType'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentType(newValue);
        }
      },
      'document.serialNumber'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentSerialNumber(newValue);
        }
      },
      'document.documentNumber'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentNumber(newValue);
        }
      },
      'document.issuingAuthority'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentIssuingAuthority(newValue);
        }
      },
      'document.issueDate'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentIssueDate(newValue);
        }
      },
      'document.expirationDate'(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.setDocumentExpirationDate(newValue);
        }
      },
    },
  };
};
